import laPicaLogo from 'images/pymes/lapica/lapicaLogo.png'
import laPica1 from 'images/pymes/lapica/lapica1.png'
import laPica2 from 'images/pymes/lapica/lapica2.png'
import laPica3 from 'images/pymes/lapica/lapica3.png'

import textiliaLogo from 'images/pymes/textilia/textiliaLogo.png'
import textilia1 from 'images/pymes/textilia/textilia1.png'
import textilia2 from 'images/pymes/textilia/textilia2.png'
import textilia3 from 'images/pymes/textilia/textilia3.png'

import laRutaLogo from 'images/pymes/laruta/laRutaLogo.png'
import laRuta1 from 'images/pymes/laruta/laRuta1.png'
import laRuta2 from 'images/pymes/laruta/laRuta2.png'
import laRuta3 from 'images/pymes/laruta/laRuta3.png'

import nailsLogo from 'images/pymes/nailsFran/nailsLogo.png'
import nails1 from 'images/pymes/nailsFran/nails1.png'
import nails2 from 'images/pymes/nailsFran/nails2.png'
import nails3 from 'images/pymes/nailsFran/nails3.png'

import fierceLogo from 'images/pymes/fierceTwerk/fierceLogo.png'
import fierce1 from 'images/pymes/fierceTwerk/fierce1.png'
import fierce2 from 'images/pymes/fierceTwerk/fierce2.png'
import fierce3 from 'images/pymes/nailsFran/nails3.png'

import innerLogo from 'images/pymes/innerPulse/innerLogo.png'
import inner1 from 'images/pymes/innerPulse/inner1.png'
import inner2 from 'images/pymes/innerPulse/inner2.png'
import inner3 from 'images/pymes/innerPulse/inner3.png'

import tejidoLogo from 'images/pymes/tejido/tejidoLogo.png'
import tejido1 from 'images/pymes/tejido/tejido1.png'
import tejido2 from 'images/pymes/tejido/tejido2.png'
import tejido3 from 'images/pymes/tejido/tejido3.png'

import daniNailsLogo from 'images/pymes/daniNails/daniNailsLogo.png'
import daniNails1 from 'images/pymes/daniNails/daniNails1.png'
import daniNails2 from 'images/pymes/daniNails/daniNails2.png'
import daniNails3 from 'images/pymes/daniNails/daniNails3.png'

import sanguruchoLogo from 'images/pymes/sangurucho/sanguruchoLogo.png'
import sangurucho1 from 'images/pymes/sangurucho/sangurucho1.png'
import sangurucho2 from 'images/pymes/sangurucho/sangurucho2.png'
import sangurucho3 from 'images/pymes/sangurucho/sangurucho3.png'

import makeupbyLogo from 'images/pymes/makeUp/makeupLogo.png'
import makeupby1 from 'images/pymes/makeUp/makeup1.png'
import makeupby2 from 'images/pymes/makeUp/makeup2.png'
import makeupby3 from 'images/pymes/makeUp/makeup3.png'

import dimassaLogo from 'images/pymes/diMazza/dimassaLogo.png'
import dimassa1 from 'images/pymes/diMazza/dimassa1.png'
import dimassa2 from 'images/pymes/diMazza/dimassa2.png'
import dimassa3 from 'images/pymes/diMazza/dimassa3.png'


import customizateLogo from 'images/pymes/customizate/customizateLogo.png'
import customizate1 from 'images/pymes/customizate/customizate1.png'
import customizate2 from 'images/pymes/customizate/customizate2.png'
import customizate3 from 'images/pymes/customizate/customizate3.png'


export const PymeChile = [
    {
      id:1,
      img:laPicaLogo,
      portada:[
        {
          id:1,
          name: laPica1,
        },
        {
          id:2,
          name: laPica2,
        },
        {
          id:3,
          name: laPica3,
        }
      ],
      author:'🇨🇱 CHILEAN FOOD 🇨🇱',
      authorTwo:'steffanilopez099@gmail.com',
      authorThree:'@a.pica.del.11',
      emp:'La pica del 11',
      description:'CYVM se inicia en el área de Servicios Contables y Tributarios desde 2015, posicionandose como líder en el mercado por su relación precio-calidad.',
      pathPage:'https://www.instagram.com/la.pica.del.11?igsh=MWZndjdiMno2dm44ag==',
      contact:'+353833429796',
      Tag:'Comida'
    },
    {
      id:2,
      img:textiliaLogo,
      portada:[
        {
          id:1,
          name: textilia1,
        },
        {
          id:2,
          name: textilia2,
        },
        {
          id:3,
          name: textilia3,
        }
      ],
      author:'Textilia',
      authorTwo:'carlitapuga@gmail.com',
      authorThree:'@textilia.ie',
      emp:'Textilia',
      description:'CYVM se inicia en el área de Servicios Contables y Tributarios desde 2015, posicionandose como líder en el mercado por su relación precio-calidad.',
      pathPage:'https://www.instagram.com/textilia.ie?igsh=eGx4eXo2bnp6aG0y',
      contact:'+353834701727',
      Tag:'Servicios'
    },
    {
      id:3,
      img:laRutaLogo,
      portada:[
        {
          id:1,
          name: laRuta1,
        },
        {
          id:2,
          name: laRuta2,
        },
        {
          id:3,
          name: laRuta3,
        }
      ],
      author:'La ruta del pan y dulce',
      authorTwo:'alejandraempresa02@gmail.com',
      authorThree:'@la_ruta_del_pan_y_dulce',
      emp:'La ruta del pan y dulce',
      description:'CYVM se inicia en el área de Servicios Contables y Tributarios desde 2015, posicionandose como líder en el mercado por su relación precio-calidad.',
      pathPage:'https://www.instagram.com/la_ruta_del_pan_y_dulce',
      contact:'+353870008187',
      Tag:'Comida'
    },    
    {
      id:4,
      img:nailsLogo,
      portada:[
        {
          id:1,
          name: nails1,
        },
        {
          id:2,
          name: nails2,
        },
        {
          id:3,
          name: nails3,
        }
      ],
      author:'Nails by Fran ',
      authorTwo:'fcaespinosav@gmail.com',
      authorThree:'@nailsbyfran.ie',
      emp:'Nails by Fran ',
      description:'CYVM se inicia en el área de Servicios Contables y Tributarios desde 2015, posicionandose como líder en el mercado por su relación precio-calidad.',
      pathPage:'https://www.instagram.com/nailsbyfran.ie?igsh=MmNsYnJ2bXM5dWc4',
      contact:'+353834135328',
      Tag:'Salud y Belleza'
    }, 
    {
      id:5,
      img:fierceLogo,
      portada:[
        {
          id:1,
          name: fierce1,
        },
        {
          id:2,
          name: fierce2,
        },
        {
          id:3,
          name: fierce1,
        }
      ],
      author:'Fierce Twerk',
      authorTwo:'muz.torres@gmail.com',
      authorThree:'@fiercetwerkclasses',
      emp:'Fierce Twerk ',
      description:'CYVM se inicia en el área de Servicios Contables y Tributarios desde 2015, posicionandose como líder en el mercado por su relación precio-calidad.',
      pathPage:'https://www.instagram.com/fiercetwerkclasses?igsh=eDk1ZHNqbjF2cWR6',
      contact:'+353834467274',
      Tag:'Actividades'
    },
    {
      id:6,
      img:innerLogo,
      portada:[
        {
          id:1,
          name: inner1,
        },
        {
          id:2,
          name: inner2,
        },
        {
          id:3,
          name: inner3,
        }
      ],
      author:'Inner pulse by Arlette',
      authorTwo:'zanyfloreschavez@gmail.com',
      authorThree:'@Inner_pulse__byarlette',
      emp:'Inner pulse by Arlette',
      description:'CYVM se inicia en el área de Servicios Contables y Tributarios desde 2015, posicionandose como líder en el mercado por su relación precio-calidad.',
      pathPage:'https://www.instagram.com/inner_pulse__byarlette?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
      contact:'+353838999120',
      Tag:'Arte'
    },
    {
      id:7,
      img:tejidoLogo,
      portada:[
        {
          id:1,
          name: tejido1,
        },
        {
          id:2,
          name: tejido2,
        },
        {
          id:3,
          name: tejido3,
        }
      ],
      author:'Tejidos garrita',
      authorTwo:'ibudin@fen.uchile.cl',
      authorThree:'@tejidos.garrita',
      emp:'Tejidos garrita',
      description:'CYVM se inicia en el área de Servicios Contables y Tributarios desde 2015, posicionandose como líder en el mercado por su relación precio-calidad.',
      pathPage:'https://www.instagram.com/tejidos.garrita?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
      contact:'+353831601953',
      Tag:'Tejido'
    },
    {
      id:8,
      img:daniNailsLogo,
      portada:[
        {
          id:1,
          name: daniNails1,
        },
        {
          id:2,
          name: daniNails2,
        },
        {
          id:3,
          name: daniNails3,
        }
      ],
      author:'ByDaniela Nails Studio',
      authorTwo:'daniela.astudillov@gmail.com',
      authorThree:'@bydaniela.ie',
      emp:'ByDaniela Nails Studio ',
      description:'CYVM se inicia en el área de Servicios Contables y Tributarios desde 2015, posicionandose como líder en el mercado por su relación precio-calidad.',
      pathPage:'https://www.instagram.com/bydaniela.ie?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
      contact:'+353833097348',
      Tag:'Salud y Belleza'
    },
    {
      id:9,
      img:sanguruchoLogo,
      portada:[
        {
          id:1,
          name: sangurucho1,
        },
        {
          id:2,
          name: sangurucho3,
        },
        {
          id:3,
          name: sangurucho2,
        }
      ],
      author:'Sangurucho´s on a truck',
      authorTwo:'ninoskaliz@gmail.com',
      authorThree:'@sanguruchos_on_a_truck',
      emp:'Sangurucho´s on a truck',
      description:'CYVM se inicia en el área de Servicios Contables y Tributarios desde 2015, posicionandose como líder en el mercado por su relación precio-calidad.',
      pathPage:'https://www.instagram.com/sanguruchos_on_a_truck?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
      contact:'+353833959350',
      Tag:'Gastronomia'
    },
    {
      id:10,
      img:makeupbyLogo,
      portada:[
        {
          id:1,
          name: makeupby1,
        },
        {
          id:2,
          name: makeupby2,
        },
        {
          id:3,
          name: makeupby3,
        }
      ],
      author:'Makeupby.cony',
      authorTwo:'Makeupby.cony@gmail.com',
      authorThree:'@makeupby.cony',
      emp:'Makeupby.cony',
      description:'CYVM se inicia en el área de Servicios Contables y Tributarios desde 2015, posicionandose como líder en el mercado por su relación precio-calidad.',
      pathPage:'https://www.instagram.com/makeupby.cony?igsh=OGdndHVta3luaHk5&utm_source=qr',      
      contact:'+353833743989',
      Tag:'Salud y Belleza'
    },
    {
      id:11,
      img:dimassaLogo,
      portada:[
        {
          id:1,
          name: dimassa1,
        },
        {
          id:2,
          name: dimassa2,
        },
        {
          id:3,
          name: dimassa3,
        }
      ],
      author:'Di Massa',
      authorTwo:'diegotroncoso.nahuel@gmail.com',
      authorThree:'@di.massaireland',
      emp:'Di Massa',
      description:'CYVM se inicia en el área de Servicios Contables y Tributarios desde 2015, posicionandose como líder en el mercado por su relación precio-calidad.',
      pathPage:'https://www.instagram.com/di.massaireland/',      
      contact:'+353830155071',
      Tag:'Gastronomia'
    },
    {
      id:12,
      img:customizateLogo,
      portada:[
        {
          id:1,
          name: customizate1,
        },
        {
          id:2,
          name: customizate2,
        },
        {
          id:3,
          name: customizate3,
        }
      ],
      author:'Customizate',
      authorTwo:'constanzapsierra@gmail.com',
      authorThree:'@customizate._',
      emp:'Customizate',
      description:'CYVM se inicia en el área de Servicios Contables y Tributarios desde 2015, posicionandose como líder en el mercado por su relación precio-calidad.',
      pathPage:'https://www.instagram.com/customizate._?igsh=M2gzOTZzeGJ6aWw5',      
      contact:'+353833743989',
      Tag:'Arte'
    },
  ]